import { Button, Image, Theme, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingCurrentDecorationProps {
  title: React.ReactElement;
  subtitle: string;
  thumbnails: {
    sourceUrl?: string | null;
    url: string;
  }[];
  onClick(): void;
  popup: React.ReactElement;
}

export const NewbuildingCurrentDecoration = ({
  title,
  subtitle,
  thumbnails,
  onClick,
  popup,
}: INewbuildingCurrentDecorationProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>{title}</div>
      <div className={styles['subtitle']}>
        <UIText2>{subtitle}</UIText2>
      </div>

      <div className={styles['gallery']} onClick={onClick}>
        <div className={styles['grid']}>
          {thumbnails.map(item => (
            <div key={item.url} className={styles['item']}>
              <Image objectFit="cover" src={item.url} />
            </div>
          ))}
        </div>
        <div className={styles['preview-button']}>
          <Button size="XS" theme="fill_white_secondary" onClick={onClick}>
            Как это может выглядеть
          </Button>
        </div>
        <div className={styles['details-button']}>
          <Theme theme="onOverlay">
            <Button size="M" theme="main_secondary" onClick={onClick}>
              Подробнее об отделке
            </Button>
          </Theme>
        </div>
      </div>
      {popup}
    </div>
  );
};
